import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { contentfulModels } from '@glowforge/ui-common';
import { orderPropType } from 'app/selectors/user';
import { shopifyMultipassUrlBuilder } from 'app/util';

import Order from './order';

import './purchase-history.less';

const { pageStringsPropType } = contentfulModels;

function getString(strings, key, defaultValue) {
  return _.get(strings, key, defaultValue);
}

const ShopifyAccountLink = (props) => {
  const { pageStrings } = props;
  const accountUrl = shopifyMultipassUrlBuilder('/account', false);
  const text = getString(
    pageStrings,
    'settings-purchase-history-shopify-link-text',
    'Newer orders may be here');

  return (
    <div className='shopifyAccountLinkContainer'>
      <a href={accountUrl}>{text}</a>
    </div>
  );
};

ShopifyAccountLink.propTypes = {
  pageStrings: pageStringsPropType.isRequired,
};

const PurchaseHistory = (props) => {
  const { pageStrings } = props;

  const orders = _.map(props.purchaseHistory, (order, index) => <Order key={index} {...order} />);

  const pageHeaderText = getString(
    pageStrings,
    'settings-purchase-history-header-text',
    'Purchase History');

  const noOrdersText = getString(
    pageStrings,
    'settings-purchase-history-empty-orders-text',
    'You have no Purchase History');

  let content;
  if (_.isEmpty(orders)) {
    content = <div className='empty'>{noOrdersText}</div>;
  } else {
    content = <div className='orderList'>{orders}</div>;
  }
  return (
    <div className='PurchaseHistory'>
      <h1 className='h2'>{pageHeaderText}</h1>
      <ShopifyAccountLink pageStrings={pageStrings} />
      {content}
    </div>
  );
};

PurchaseHistory.propTypes = {
  purchaseHistory: PropTypes.arrayOf(PropTypes.shape(orderPropType)),
  pageStrings: pageStringsPropType.isRequired,
  isManagePending: PropTypes.bool,
};

PurchaseHistory.defaultProps = {
  purchaseHistory: [],
};

export default PurchaseHistory;



// WEBPACK FOOTER //
// ./app/components/settings/purchase-history.jsx